module.exports = __webpack_public_path__ + "assets/ig-edit.64014efa.svg";